/* WHOSE TURN IS IT, UNDER WHICH NAME.

   A player ends their turn by typing "done" or clicking the End turn button in
   Roll20 chat. Roll20 tells us the name the message was SENT AS, which is not
   reliably the name on this tracker: it may be the player's account name, the
   token's name, a doppelganger's alias, or a character who has not told the
   party their real name.

   So a row carries several names it might answer to, and the speaker is matched
   against all of them. Reported 2026-09-29: an End turn was refused on this
   comparison and the DM saw only a turn that did not advance -- the refusal was
   correct, but the reasoning lived inline in a component and nothing tested it.
   It is here so it can be. */
import { normLoose } from "./text";

const firstWord = (s: string) => s.split(" ")[0];

/** Does the name that spoke own the turn?
 *
 *  A first-name match counts: Roll20 shows "Pryze" for "Pryze Noctivar" often
 *  enough that demanding the full name would refuse honest clicks. It is
 *  deliberately loose -- the cost of a wrong accept is one turn advanced early,
 *  which the DM steps back; the cost of a wrong refuse is a button that looks
 *  broken, which is what actually happened. */
export function speakerOwnsTurn(said: unknown, candidates: readonly (string | null | undefined)[]): boolean {
  /* Names that normalise to nothing are dropped, not kept as "": a row whose
     only name is punctuation or whitespace would otherwise refuse every End
     turn for the rest of the fight. Nothing can be compared, so trust. */
  const mine = (candidates || []).map((n) => normLoose(n)).filter((n) => n.length > 0);
  const who = normLoose(said);
  if (!who || !mine.length) return true;
  return mine.some((n) => n === who || firstWord(n) === firstWord(who));
}
